module.exports = __webpack_public_path__ + "img/heron_icon.5e367ab9.svg";